import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "@/redux-store";
import "@/configs/i18n";
import "./App.css";
// Stil importları
import "@/styles/main.scss";

// Sayfalar ve bileşenler
import BookDetail from "./pages/bookDetail";
import SmartBook from "./pages/smartBook";
import { ExtraToolProvider } from "./contexts/ExtraToolContext";
import { DrawingContextProvider } from "./contexts/DrawingContext";
import { ModalContextProvider } from "./contexts/ModalContext";
import { ShowAnswerContextProvider } from "./contexts/ShowAnswerContext";
import { SidebarProvider } from "./contexts/SideBarContext";
import SplashScreen from "./pages/Splash";
import Books from "./pages/books";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import axios from "axios";
import { apiConfig } from "./configs/appConfig";
import { UserContext } from "./contexts/UserContext";

function App() {
  const queryClient = new QueryClient();

  const [userInfo, setUserInfo] = useState<any>(null);
  const location = useLocation();

  useEffect(() => {
    axios.get(apiConfig.baseWeb + "/" + apiConfig.userInfo).then((res) => {
      setUserInfo(res.data);
      //önce yetki kontrolü yapılıyor eğer misafire yetki verilmişse uygulama kullanımına yönlendiriliyor
      const hasPermission =
        res.data.AllowedPermissions.some(
          (permission: any) =>
            permission.Screen === "MobileApp" &&
            permission.Action === "Plugins.MobileApp.DownloadLibrary"
        ) || res.data.IsAdmin;
      if (!hasPermission) {
        if (res.data.IsAuthenticated) {
          // giriş yapılmış ve yetki yoksa
          window.location.href = apiConfig.baseWeb;
        } else {
          window.location.href =
            apiConfig.baseWeb +
            `/giris?returnUrl=${location ? "/library" + location.pathname : ""}`;
        }
      }
    });
  }, [location, location.pathname]);

  return (
    <Provider store={store}>
      <UserContext.Provider value={{ userInfo, setUserInfo }}>
        <QueryClientProvider client={queryClient}>
          <ExtraToolProvider>
            <DrawingContextProvider>
              <ModalContextProvider>
                <SidebarProvider>
                  <ShowAnswerContextProvider>
                    <div className="app">
                      <Routes>
                        <Route path="/" element={<SplashScreen />} />
                        <Route path="/books" element={<Books />} />
                        <Route
                          path="/book-detail/:bookId"
                          element={<BookDetail />}
                        />
                        <Route
                          path="/book-group/:bookId"
                          element={<BookDetail />}
                        />
                        <Route
                          path="/smartBook/:bookId/:pageNo?"
                          element={<SmartBook />}
                        />
                      </Routes>
                    </div>
                  </ShowAnswerContextProvider>
                </SidebarProvider>
              </ModalContextProvider>
            </DrawingContextProvider>
          </ExtraToolProvider>
        </QueryClientProvider>
      </UserContext.Provider>
    </Provider>
  );
}

export default App;
